{
	"title": "Teams & entries",
	"subtitle": "Every entry in {{games}}, in programme order. Click a row to open the entry and its roster.",
	"detailTitle": "Entry",
	"status": {
		"ENTERED": "Entered",
		"WITHDRAWN": "Withdrawn",
		"DISQUALIFIED": "Disqualified"
	},
	"role": {
		"ATHLETE": "Athlete",
		"RESERVE": "Reserve",
		"GUIDE": "Guide",
		"PILOT": "Pilot",
		"COX": "Cox"
	},
	"filters": {
		"label": "Filter the entries",
		"search": "Team, athlete or NOC",
		"sport": "Sport",
		"allSports": "All sports",
		"discipline": "Discipline",
		"allDisciplines": "All disciplines",
		"event": "Event",
		"allEvents": "All events",
		"pickSportFirst": "Pick a sport first",
		"noc": "NOC",
		"allNocs": "All NOCs",
		"status": "Status",
		"anyStatus": "Any status"
	},
	"table": {
		"event": "Event",
		"entry": "Entry",
		"noc": "NOC",
		"members": "Members",
		"status": "Status",
		"open": "Open {{name}}",
		"count_one": "{{n}} entry",
		"count_other": "{{n}} entries"
	},
	"empty": {
		"filteredTitle": "No entries match these filters",
		"filteredBody": "Clear a filter, or reset them all to see every entry.",
		"reset": "Reset filters",
		"noneTitle": "No entries in {{games}} yet",
		"noneBody": "Entries are made in each event's start list.",
		"noGamesTitle": "No games are set up yet",
		"noGamesBody": "Games are created in GMS. Ask your administrator."
	},
	"errors": {
		"gamesTitle": "The games could not load"
	},
	"manage": {
		"reasonLabel": "Reason",
		"reasonTooLong": "Keep the reason to {{max}} characters.",
		"edit": {
			"button": "Edit entry",
			"title": "Edit {{name}}",
			"hint": "Leave a field empty to clear it. The entry number, organisation and roster do not change here.",
			"markPlaceholder": "e.g. 7.85 or 10.12",
			"save": "Save",
			"done": "Entry saved",
			"seedError": "Type the seed as a whole number from 1, or leave it empty.",
			"markError": "Keep the entry mark to {{max}} characters.",
			"bibError": "Keep the bib to {{max}} characters.",
			"bibHint": "The bib follows the athlete into every meet of this event, and the venue console matches on it. A bib typed on one meet's start list wins for that meet.",
			"nothing": "Nothing changed."
		},
		"withdraw": {
			"button": "Withdraw",
			"title": "Withdraw {{name}}?",
			"body": "The entry stays on record but will not compete. It no longer counts toward the organisation's entry limit. You can reinstate it later.",
			"reasonPlaceholder": "e.g. Injured, replaced by the reserve",
			"confirm": "Withdraw entry",
			"done": "{{name}} withdrawn"
		},
		"reinstate": {
			"button": "Reinstate",
			"title": "Reinstate {{name}}?",
			"body": "The entry is entered again and counts toward the organisation's entry limit.",
			"confirm": "Reinstate entry",
			"done": "{{name}} reinstated"
		},
		"delete": {
			"button": "Delete entry",
			"title": "Delete {{name}}?",
			"body": "The entry and its roster are removed from the event. Use Withdraw instead to keep it on record.",
			"reasonPlaceholder": "e.g. Entered in the wrong event",
			"confirm": "Delete entry",
			"done": "{{name}} deleted",
			"inMeets_one": "In {{n}} meet: take it off the start list to delete it.",
			"inMeets_other": "In {{n}} meets: take it off the start lists to delete it."
		},
		"refused": {
			"quota": "This event takes at most {{max}} entries per organisation, and it is full. Withdraw another entry first.",
			"inUse": "This entry holds a place in a meet or a medal. Take it off the start list first, or withdraw it instead.",
			"locked": "This event is locked: its entries cannot change until it is unlocked.",
			"forbidden": "Your login may not change entries in this sport.",
			"gone": "This entry no longer exists. It may have been deleted on another screen.",
			"offline": "The server could not be reached. Nothing was changed: try again.",
			"other": "The change could not be saved. Reload the page and try again."
		}
	},
	"detail": {
		"loading": "Loading the entry…",
		"notFoundTitle": "This entry does not exist",
		"notFoundBody": "It may have been removed from its event. Find it again in Teams & entries.",
		"backToList": "All teams & entries",
		"facts": {
			"type": "Type",
			"entryNo": "Entry number",
			"seed": "Seed",
			"entryMark": "Entry mark",
			"bib": "Bib",
			"status": "Status"
		},
		"individual": "Individual",
		"team": "Team",
		"roster": {
			"title": "Roster",
			"subtitle_one": "{{n}} member. Click a row to open the athlete.",
			"subtitle_other": "{{n}} members. Click a row to open the athlete.",
			"order": "Order",
			"name": "Name",
			"role": "Role",
			"bib": "Bib",
			"class": "Class",
			"captain": "Captain",
			"open": "Open {{name}}",
			"none": "No one is on this roster yet.",
			"readOnly": "Rosters are read-only here. To change this entry, use the start list:",
			"readOnlyNoMeet": "Rosters are read-only here. Entries are changed in a meet's start list, once the event has meets."
		},
		"meets": {
			"title": "Meets of this event",
			"subtitle_one": "This entry is in {{n}} of them. Open a start list to see the line-up.",
			"subtitle_other": "This entry is in {{n}} of them. Open a start list to see the line-up.",
			"subtitleNone": "This entry is not in a meet yet. Open a start list to see the line-up.",
			"meet": "Meet",
			"time": "Time",
			"status": "Status",
			"thisEntry": "This entry",
			"inMeet": "In this meet",
			"pool": "{{phase}} {{pool}}",
			"startList": "Start list",
			"openStartList": "Open the start list of meet {{meet}}",
			"none": "This event has no meets yet."
		},
		"structureError": "The event's meets could not load"
	},
	"addEntry": {
		"button": "Add entry",
		"title": "Add entry",
		"subtitle": "Enter a team or an athlete in an event. Entries show in each meet's start list.",
		"sport": "Sport",
		"event": "Event",
		"noc": "NOC",
		"pickSport": "Pick a sport",
		"pickSportFirst": "Pick a sport first",
		"pickEvent": "Pick an event",
		"pickNoc": "Pick an NOC",
		"nocHint": "Who the entry competes for. It cannot be changed once saved.",
		"teamName": "Team name",
		"teamNameHint": "Optional. Without one, the team is named by its NOC (Malaysia 1, Malaysia 2).",
		"entryNo": "Entry no.",
		"entryNoHint": "Blank: the NOC's next number.",
		"seed": "Seed",
		"seedHint": "Optional.",
		"individualHint": "One athlete per entry.",
		"sizeExact_one": "{{count}} player per team.",
		"sizeExact_other": "{{count}} players per team.",
		"sizeRange": "{{min}} to {{max}} players per team, reserves included.",
		"sizeMin_one": "At least {{count}} player per team.",
		"sizeMin_other": "At least {{count}} players per team.",
		"sizeMax_one": "At most {{count}} player per team.",
		"sizeMax_other": "At most {{count}} players per team.",
		"rosterTeam": "Players",
		"rosterIndividual": "Athlete",
		"squadCount_one": "{{n}} player",
		"squadCount_other": "{{n}} players",
		"rosterEmpty": "Nobody yet. Add people from the list below.",
		"roleFor": "Role for {{name}}",
		"captain": "Captain",
		"remove": "Remove",
		"removeName": "Remove {{name}}",
		"pickPeople": "Shortlisted athletes of this NOC",
		"search": "Search by name",
		"searchButton": "Search",
		"add": "Add",
		"addName": "Add {{name}}",
		"noPeople": "Nobody of this NOC can be entered here. Only athletes shortlisted for this event in the GMS can be entered, and not someone already in another entry of this event.",
		"noPeopleSearch": "Nobody matches that name.",
		"peopleError": "The people could not be loaded. Try again.",
		"morePeople": "Showing {{n}} of {{total}}. Search by name to find the rest.",
		"cancel": "Cancel",
		"save": "Save entry",
		"saveAnother": "Save and add another",
		"saved": "{{name}} entered in {{event}}.",
		"issue": {
			"noOrganization": "Pick the NOC.",
			"emptyRoster": "Add at least one person.",
			"oneAthlete": "An individual entry has exactly one athlete.",
			"squadSize": "This event needs {{size}}",
			"number": "A whole number from 1 to 32767, or blank.",
			"notShortlisted": "Someone on the roster is not shortlisted for this event: they can only be a guide, pilot or cox."
		},
		"errors": {
			"personEntered": "Someone marked below is already in another entry of this event.",
			"personGone": "Someone on the roster no longer exists. Remove them and try again.",
			"squadSize": "The roster does not fit this event's team size.",
			"oneAthlete": "An individual entry has exactly one athlete.",
			"teamNameIndividual": "Entries in an individual event have no team name.",
			"entryNoTaken": "This NOC already uses that entry number in this event.",
			"organizationGone": "That NOC no longer exists. Pick another.",
			"quota": "This NOC already has the most entries this event allows ({{max}}).",
			"invalid": "Not accepted. Check this field.",
			"locked": "This event is locked: its entries cannot change until it is unlocked.",
			"forbidden": "Your login may not enter competitors in this sport.",
			"eventGone": "This event no longer exists. Close and reload the page.",
			"offline": "No answer from the server. Nothing was saved. Try again.",
			"auth": "Your session has ended. Sign in again.",
			"idTaken": "Something went wrong with this form. Close it and start again.",
			"generic": "Not saved ({{code}}). Try again.",
			"notShortlisted": "Someone marked below is no longer shortlisted for this event in the GMS. Remove them and try again."
		},
		"shortlistNote": "Only athletes shortlisted for this event in the GMS can be entered as an athlete or reserve.",
		"shortlistRole": {
			"PRIMARY": "Primary",
			"RESERVE": "Reserve",
			"none": "Support only"
		},
		"supportNote": "Guides, pilots and coxes need no shortlist: anyone with a card under this NOC can be added in one of those roles.",
		"pickMode": {
			"shortlisted": "Shortlisted athletes",
			"support": "Guides, pilots, coxes"
		},
		"pickModeLabel": "Who to list",
		"pickPeopleSupport": "People of this NOC",
		"noPeopleSupport": "Nobody of this NOC can be added: they need a card under it, and must not be in another entry of this event.",
		"supportSearchFirst": "Type at least {{n}} letters of a name and press Search to find a guide, pilot or cox."
	}
}
